function collapsibleBlock(){
  var wrapper = ".wrapper"; //wrapper inside collapsible
  var collapsibles = document.querySelectorAll(".collapsible");
  var buttons = document.querySelectorAll("button[data-collapsible-target], a[data-collapsible-target]");
  // Add class to the blocks that are going to be animated
  updateHeight(collapsibles);

  window.addEventListener('resize', function() {
    updateHeight(collapsibles);
  }, true);

  function updateHeight(c){
    for(var i = 0; i < c.length; i++ ){
      if(c[i].classList.contains("collapsed")){
        c[i].style.maxHeight = "0px";
      }
      else{
        var w = c[i].querySelector(wrapper);
        c[i].style.maxHeight = getSize(w).offsetHeight+"px";
      }
    }
  }

  // Add listener to buttons
  for(var i = 0; i < buttons.length; i++ ){
    var button = buttons[i];

    if ( button.getAttribute('data-collapsible-afterclick') == "change"){
      var textTarget = button.getAttribute('data-collapsible-texttarget');
      if(!textTarget){
        button.setAttribute('data-collapsible-textclosed', button.innerHTML );
      }
      else{
        var t = button.querySelector(textTarget);
        button.setAttribute('data-collapsible-textclosed', t.innerHTML );
      }
    }

    button.addEventListener('click', function(e) { 
      e.preventDefault();
      handleSelf(this, this.getAttribute('data-collapsible-afterclick'));
      toggle(this.getAttribute('data-collapsible-target')) ;
    });
  }

  function handleSelf(trigger, behavior){
    var b = (behavior !== null) ? behavior : "hide";
    switch (b) {
      case "hide":
          trigger.classList.add("hidden");
          break;
      case "change":
          toggleText(trigger, trigger.getAttribute('data-collapsible-textclosed'), trigger.getAttribute('data-collapsible-textopen'));
          break;
    }
  }

  function toggle(targetBlock){
    var t = document.querySelector(targetBlock);
    var w = t.querySelector(wrapper);
    if(t.classList.contains("collapsed")){
      t.classList.remove("collapsed");
      t.style.maxHeight = Math.max(w.clientHeight, w.innerHeight || 0)+"px";
    }
    else{
      t.classList.add("collapsed");
      t.style.maxHeight = "0px";
    }
  }

  function toggleText(targetButton, closedText, openText){
    var t = targetButton;
    var cText = (closedText !== null ) ? closedText :  "View more";
    var oText = (openText !== null ) ? openText :  "View less";

    var textTarget = t.getAttribute('data-collapsible-texttarget');
    if(textTarget) var innerTarget = t.querySelector(textTarget);

    if(t.classList.contains("block-active")){
      t.classList.remove("block-active");

      if(!textTarget){
        t.innerHTML = cText;
      }
      else{
        innerTarget = cText;
      }
    }
    else{
      t.classList.add("block-active");

      if(!textTarget){
        t.innerHTML = oText;
      }
      else{
        innerTarget = oText;
      }
    }
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
DOMReady(function() {
  if(document.querySelector('.collapsible')) collapsibleBlock();
});
